
export default {
    SET_NAVIGATOR(state, payload) {
        state.navigator = payload;
    },
    FETCH_STATE(state, payload) {
        state.scrollFetching = payload;
    },
    SET_HOME(state, payload) {
        state.homePage = { ...state.homePage, ...payload };
    },
    SET_PROMOTION(state, payload) {
        state.promotion = { ...state.promotion, ...payload };
    },
    SET_PLAY(state, payload) {
        state.playPage = { ...state.playPage, ...payload };
    },
    SET_CATEGORY(state, payload) {
        state.categoryPage = { ...state.categoryPage, ...payload };
    },
    SET_RESULT(state, payload) {
        state.resultPage = { ...state.resultPage, ...payload };
    },
    SET_GLOBLE(state, payload) {
        state.globle = { ...state.globle, ...payload };
    }
}; 